
import { Button, Row, Col, Card } from 'react-bootstrap';
import { Redirect } from "react-router-dom";
import { Form, Prototipo } from './Form';
import { toast } from 'react-toastify';
import { Evento } from '../../Models/Model';
import { getEvento } from '../index';
interface Props {
    evento: Evento
}
export default function Edit() {
    const e = getEvento();
    return <EditClass evento={e} />
}
class EditClass extends Prototipo<Props> {
    constructor(p: Props) {
        super(p)
        this.state = { ...p.evento, Redirect: false };
    }
    render = () => {
        let { setData, error, state, create } = this;
        if (state.Redirect) return <Redirect to={'/evento'} />
        return (<Card>
            <Card.Header className='bg-info'>
                <h4 className='mr-auto'><i className="fa fa-edit"></i> ACTUALIZAR EVENTO </h4>
            </Card.Header>
            <Form codigo={this.props.evento.codigo} data={state} setData={setData as any} error={error}>
                <Row className='mt-2'><Col xs={12}>
                    <Button variant='success' className='float-right' onClick={create}>
                        <i className="fa fa-save"></i> Guardar
                    </Button>
                </Col></Row>
            </Form>
        </Card >)
    }
    create = () => {
        if (this.validar()) {
            if (this.procesar) {
                this.procesar = false;
                this.con.actualizar(this.props.evento.id, this.getDataSave(), () => {
                    this.procesar = true;
                    toast('EVENTO ACTUALIZADO', { type: toast.TYPE.SUCCESS });
                    this.setState({ Redirect: true });
                }, this.setError)
            }
        } else this.forceUpdate();
    }
}